import { TLocalizationKey } from 'types/i18n';

export const LOYALTY_EXCLUDED_GROUP = 'EXCLUDED_FROM_LOYALTY';

export const storeHoursSummary = [
  ['monday', 'mon'],
  ['tuesday', 'tue'],
  ['wednesday', 'wed'],
  ['thursday', 'thr'],
  ['friday', 'fri'],
  ['saturday', 'sat'],
  ['sunday', 'sun'],
] as const satisfies ReadonlyArray<readonly [TLocalizationKey, string]>;
